<ng-container *ngIf="!isNewProductSelector; then oldTemplate; else newTemplate"></ng-container>
<ng-template #oldTemplate>
  <h3
    *ngIf="
      (focusedTileIdDetails?.lineTileType === 2 &&
        focusedTileIdDetails?.services &&
        focusedTileIdDetails?.services?.servicesList?.length > 0) ||
      focusedTileIdDetails?.lineTileType === 1 ||
      focusedTileIdDetails?.lineTileType === 0
    "
    class="m-t-xl"
  >
    {{ softGoodsAEMContent?.services }}
  </h3>
  <div
    *ngIf="
      focusedTileIdDetails?.lineTileType === 2 && !focusedTileIdDetails?.isUpgrade;
      else displayServicesForNewLines
    "
  >
    <div class="row m-t-lg" *ngFor="let service of focusedTileIdDetails?.services?.servicesList">
      <div class="col-8 col-md-5 n-padding-r">
        <p class="alert-text"><em class="fa fa-check def alert-icon"></em>{{ service }}</p>
        <p class="small icon-text m-t-xs" *ngIf="false"></p>
      </div>
      <div class="col-4 col-md-2 text-end" *ngIf="false">
        <p class="lead">$4</p>
        <p class="xsmall m-t-xs">{{ softGoodsAEMContent?.perMonth }}</p>
      </div>
    </div>
  </div>
  <ng-template #displayServicesForNewLines>
    <div class="row m-t-lg">
      <div class="col-12">
        <p-accordion class="internal-blade m-t-lg" id="p-accordion-default-30">
          <p-accordionTab
            #accordionTabServices
            [disabled]="disableServiceBlade"
            [selected]="eligibleServices?.length > 0"
            id="p-accordionTab-default-39"
          >
            <p-header>
              <h6 class="title">{{ softGoodsAEMContent?.serviceOption }}</h6>
              <p class="blade-desc">{{ softGoodsAEMContent?.aServiceForEveryNeedLabel }}</p>
            </p-header>
            <div class="row" *ngIf="error">
              <div class="col-12 m-t-lg">
                <tmo-error-message-detail
                  id="error-message-detail"
                  [errorMessage]="errorMessage"
                ></tmo-error-message-detail>
              </div>
            </div>
            <div *ngIf="eligibleServices?.length === 0">
              <p class="content">
                <i class="fa fa-flag def alert-icon p-r-sm"></i
                >{{ softGoodsAEMContent?.noserviceAvailable }}
              </p>
            </div>
            <div
              class="p-content"
              *ngIf="
                eligibleServices &&
                  !focusedTileIdDetails?.noPlanNeeded &&
                  focusedTileIdDetails?.plansFromCart?.id;
                else displayServiceMessage
              "
            >
              <div
                [class]="serviceIndex === 0 ? 'row' : 'row m-t-md'"
                *ngFor="let service of eligibleServices; let serviceIndex = index"
              >
                <div class="col-9 col-md-6 n-padding-r">
                  <label [class]="serviceIndex === 0 ? 'form-label m-t-xs' : 'form-label'">
                    <tmo-checkbox
                      [(ngModel)]="service.selected"
                      [name]="'service.offerName' + serviceIndex"
                      (onClick)="handleClickEvent(service.id)"
                      [disabled]="!service.enabled"
                      [checkboxTitle]="softGoodsAEMContent?.serviceOption"
                      [id]="'Service-' + service?.id"
                    >
                      <p [ngClass]="{ 'text-disabled': !service.enabled }">
                        {{ service?.offerName }}
                      </p>
                      <!-- <p *ngIf="isAssistedFlow" [ngClass]="{'text-disabled': !service.enabled}" class="content xsmall m-t-xs">
                     ({{softGoodsAEMContent?.offerCode}}: {{service?.offerCode}})</p> -->
                    </tmo-checkbox>
                  </label>
                </div>
                <div class="col-3 col-md-2 text-end n-padding-l">
                  <p [ngClass]="{ 'text-disabled': !service.enabled }" class="lead price">
                    {{
                      service?.price?.monthlyPrice?.salePrice?.amount | currency: 'USD' : 'symbol'
                    }}
                  </p>
                  <p [ngClass]="{ 'text-disabled': !service.enabled }" class="xsmall m-t-xs">
                    {{ softGoodsAEMContent?.perMonth }}
                  </p>
                </div>
                <div class="col-8 col-md-6 radio-check-spacer">
                  <div *ngIf="service?.description">
                    <div class="col-12 m-t-sm">
                      <tmo-see-more-see-less
                        id="see-more-see-less"
                        [removeRowClass]="true"
                        [browseService]="true"
                        [textDisable]="!service.enabled ? true : null"
                        [limit]="140"
                        [inputText]="service?.description"
                        [seeMoreText]="softGoodsAEMContent?.seeMore"
                        [seeLessText]="softGoodsAEMContent?.seeLess"
                      >
                      </tmo-see-more-see-less>
                    </div>
                  </div>
                </div>
                <ng-container
                  *ngIf="
                    service.selected &&
                    service?.alternativeDescription &&
                    service?.alternativeDescription?.length
                  "
                >
                  <div class="col-12">
                    <div class="col-12 m-t-sm">
                      <p class="m-t-sm m-l-md legal">
                        {{ service?.alternativeDescription[0].text }}
                      </p>
                    </div>
                  </div>
                </ng-container>
                <div
                  class="col-12 m-l-md"
                  *ngIf="service?.conflictsAndWarnings && service?.conflictsAndWarnings?.length > 0"
                >
                  <div
                    class="col-8"
                    *ngIf="hardConflictNotifications && hardConflictNotifications[serviceIndex]"
                  >
                    <p class="alert-text small m-t-sm">
                      <i id="hard-conflict-notification" class="fa fa-flag def alert-icon"></i>
                      {{ hardConflictNotifications[serviceIndex] }}
                    </p>
                  </div>
                  <div
                    class="col-8"
                    *ngIf="softConflictNotification && softConflictNotification[serviceIndex]"
                  >
                    <p class="alert-text small m-t-sm">
                      <i id="hard-conflict-notification" class="fa fa-flag def alert-icon"></i>
                      {{ softConflictNotification[serviceIndex] }}
                    </p>
                  </div>
                </div>
                <div
                  class="col-12 m-l-md"
                  *ngIf="cartServiceError && cartServiceError?.offerId === service?.offerCode"
                >
                  <div class="col-8">
                    <p class="alert-text small m-t-sm">
                      <i id="hard-conflict-notification" class="fa fa-flag def alert-icon"></i>
                      <span> {{ cartServiceError?.warningDescription }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="row m-t-lg">
                <div class="col-9 col-md-6 n-padding-r">
                  <p
                    class="content"
                    id="service-section-see-all-services-link"
                    *ngIf="eligibleServices?.length > 0 && !isUpgrade"
                  >
                    <a
                      class="lead"
                      href="javascript:void(0)"
                      [routerLink]="serviceSectionConstants.NAV_BROWSE_SERVICES"
                      id="cta-default-142"
                    >
                      {{ softGoodsAEMContent?.seeAllServices }}
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <ng-template #displayServiceMessage>
              <div class="p-content">
                <p>
                  <i
                    id="plan-service-options-notification"
                    class="fa fa-flag def alert-icon p-r-sm"
                  ></i
                  >{{ softGoodsAEMContent?.planServiceOptionsNotification }}
                </p>
              </div>
            </ng-template>
          </p-accordionTab>
        </p-accordion>
      </div>
    </div>
  </ng-template>
</ng-template>
<ng-template #newTemplate>
  <div
    *ngIf="
      !(focusedTileIdDetails?.lineTileType === 2 && !focusedTileIdDetails?.isUpgrade);
      else servicesList
    "
  ></div>
  <div
    *ngIf="
      (!!isAllZeroDollarService && isServiceEditable) ||
      !isAllZeroDollarService ||
      !skipZeroDollarService
    "
    [ngClass]="{ hideLine: isServiceBlockEnable, textWrap: tabsTitle && tabsTitle?.length > 1 }"
  >
    <p-accordion
      class="newTemplate internal-blade m-t-lg hideIcon"
      [ngClass]="{ 'service-popup': fromModal }"
      id="p-accordion-default-30"
    >
      <h3 *ngIf="fromModal">{{ softGoodsAEMContent?.services }}</h3>
      <p-accordionTab
        #accordionTabServices
        [disabled]="!isServiceBlockEnable"
        [selected]="isServiceBlockEnable"
        id="p-accordionTab-service"
      >
        <p-header class="p-s-2">
          <h3
            *ngIf="!fromModal"
            class="f-20"
            [ngClass]="{
              'text-disabled': !isServiceBlockEnable,
              'header-text-disable': !isServiceBlockEnable,
              'mt-4': !skipEnable && isServiceBlockEnable && eligibleServices?.length,
            }"
          >
            {{ softGoodsAEMContent?.services }}
          </h3>
          <button
            (click)="skipService($event)"
            class="btn btn-link skipService ps-0 pt-2 pb-5 m-0 relative"
            role="link"
            type="submit"
            *ngIf="!skipEnable && isServiceBlockEnable && eligibleServices?.length && !fromModal"
          >
            {{ softGoodsAEMContent?.skipServices }}
            <i class="fa fa-angle-right button-icon-angle-right"></i>
          </button>
        </p-header>
        <div class="row" *ngIf="error && !fromModal">
          <div class="col-12 m-t-lg">
            <tmo-error-message-detail
              id="error-message-detail"
              [errorMessage]="errorMessage"
            ></tmo-error-message-detail>
          </div>
        </div>
        <div *ngIf="eligibleServices?.length === 0 && !fromModal">
          <p class="ps-0 error-text pt-2 f-11 lh-1d5">
            <i class="fa fa-flag def alert-icon p-r-sm"></i>
            {{ softGoodsAEMContent?.noserviceAvailable }}
          </p>
        </div>
        <p-tabView [activeIndex]="activeTabIndex">
          <p-tabPanel *ngFor="let title of tabsTitle" [header]="title">
            <div class="row">
              <div
                class="col-12"
                [ngClass]="{ 'col-md-12': fromModal, 'col-md-7': !fromModal }"
                *ngIf="eligibleServices?.length && focusedTileIdDetails?.plansFromCart?.id"
              >
                <tmo-service-details
                  [planFamilyName]="title"
                  (clickEvent)="handleClickEvent($event)"
                  [eligibleServices]="eligibleServices"
                  [softConflictNotification]="softConflictNotification"
                  [softGoodsAEMContent]="softGoodsAEMContent"
                  [hardConflictNotifications]="hardConflictNotifications"
                >
                </tmo-service-details>
              </div>
            </div>
          </p-tabPanel>
        </p-tabView>
        <div
          class="button-box text-align: center text-center-sm text-md-left"
          [ngClass]="{ 'btn-center': fromModal }"
        >
          <button
            id="go-to-cart1"
            class="btn btn-primary btn-boder mb-4 b_btnWrapp"
            (click)="goToCart()"
          >
            {{ softGoodsAEMContent?.continue }}
          </button>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>
</ng-template>

<ng-template #servicesList>
  <h3 class="m-t-xl">
    {{ softGoodsAEMContent?.services }}
  </h3>
  <div class="row m-t-lg" *ngFor="let service of focusedTileIdDetails?.services?.servicesList">
    <div class="col-8 col-md-5 n-padding-r">
      <p class="alert-text"><em class="fa fa-check def alert-icon"></em>{{ service }}</p>
    </div>
  </div>
</ng-template>
<tmo-dynamic-modal [modal]="serviceWarningModal">
  <ng-container header>
    <div class="modal-logo-close">
      <i class="logo-icon t-icon t-icon-logo"></i>
      <a
        href="javascript:void(0)"
        class="close-x pull-right"
        (click)="closeModal()"
        id="cta-default-220"
        ><i class="fa fa-times"></i
      ></a>
    </div>
    <div class="row">
      <h3>{{ softGoodsAEMContent?.warningMessage }}</h3>
    </div>
  </ng-container>
  <div *ngFor="let line of modalDescription">
    <div class="row" *ngFor="let warning of line.warnings">
      <div class="col-12">
        <p class="small">{{ warning?.warningDescription }}</p>
      </div>
    </div>
  </div>
  <ng-container footer>
    <div class="col-12 buttons-container button-spacing">
      <div class="button-box">
        <button class="btn btn-primary" (click)="closeModal()" id="btn-default-292">
          {{ softGoodsAEMContent?.continue }}
        </button>
      </div>
    </div>
  </ng-container>
</tmo-dynamic-modal>
<tmo-spinner [setDelay]="!showSpinner"></tmo-spinner>
